module.exports = __webpack_public_path__ + "img/symphony_734_camel.ddaa4199.jpg";